import { utilities, logging } from '@pulte/pulte-myloan-npm';
import { mapGetters } from 'vuex';

const utilitiesMixin = {
  data() {
    return {
      utilities: null,
      logging: null
    };
  },
  computed: {
    ...mapGetters(['siteLinks', 'isAuthenticated', 'paymentLink'])
  },
  mounted() {
    this.utilities = utilities(this.$router);
    this.logging = logging;
  },
  methods: {
    learnMore(siteSpecificLink) {
      var link = this.$store.getters.specificSiteLink(siteSpecificLink);
      if (link.target === '_self') {
        this.utilities.navigation.doNav(
          link.url,
          this.$route.name,
          this.$options.analyticsCategory + ' - Help Info - ' + siteSpecificLink
        );
      } else {
        this.utilities.navigation.doNewWindowNav(
          link.url,
          this.$route.name,
          this.$options.analyticsCategory + ' - Help Info - ' + siteSpecificLink
        );
      }
    },
    doStartYourLoan() {
      if (this.isAuthenticated) {
        const startUrl = this.siteLinks.find(({ key }) => key === 'startUrl')
          .url;
        this.utilities.navigation.doNav(
          startUrl,
          this.$route.name,
          this.$options.analyticsCategory
        );
      } else {
        this.utilities.navigation.doNav(
          'login',
          this.$route.name,
          this.$options.analyticsCategory
        );
      }
    },
    makePayment(siteSpecificLink) {
      const paymentUrl = this.siteLinks.find(({ key }) => key === 'paymentLink')
          .url;
      this.utilities.navigation.doNewWindowNav(
        paymentUrl,
        this.$route.name,
        this.$options.analyticsCategory + ' - Help Info - ' + siteSpecificLink
      );     
    }
  }
};

export default utilitiesMixin;
